export enum snackbarTypes {
    success,
    error,
    warning,
    info,
    loading
}

export enum dialogTypes {
    none,
    forbidden,
    expired
}
